module.exports = __webpack_public_path__ + "media/styles/images/svg/courses-gray-c2788015a301692978fbb1e7aabc7ad4.svg";